"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusPresseSelect = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var form_1 = require("../../form");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var StatusPresseSelect = function (_a) {
    var props = __rest(_a, []);
    var messages = (0, useFormattedMessages_1.default)('form.statusPresseSelect');
    var statuses = [{
            label: messages.status,
            value: '',
        }, {
            label: messages.employee,
            value: messages.employee,
        }, {
            label: messages.freelancer,
            value: messages.freelancer,
        }];
    return (0, jsx_runtime_1.jsx)(form_1.Select, __assign({}, props, { options: statuses, emptyValue: statuses[0].value }), void 0);
};
exports.StatusPresseSelect = StatusPresseSelect;
exports.default = exports.StatusPresseSelect;
